var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHeadphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2c4.126 0 7.523 3.065 7.954 7H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1.026A8.024 8.024 0 0 1 12 21a1.251 1.251 0 0 1-1.263-1.24c0-.683.565-1.238 1.263-1.238a5.5 5.5 0 0 0 4.457-2.252A1.983 1.983 0 0 1 16 15v-4a2 2 0 0 1 1.418-1.914C17.041 6.48 14.76 4.478 12 4.478c-2.76 0-5.041 2.003-5.419 4.607A2.002 2.002 0 0 1 8 11v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h.046C4.477 5.065 7.874 2 12 2Z",
  fill: "currentColor"
}))));

export default SvgHeadphone;